import { SingleValueRxEmitter } from '@ocodelib/ex-util';

/**
 * 라이트박스가 오픈되었는지 여부
 */
export const LightboxOpenEvent = new SingleValueRxEmitter(false);
